var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"relative bg-[#28aae2] min-w-[39px] max-w-[39px] min-h-[39px] max-h-[39px] rounded-full"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }